import { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import html2canvas from 'html2canvas-pro'
import jsPDF from 'jspdf'

const captureSection = async (section) => {
  return html2canvas(section, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    allowTaint: true,
    scrollY: -window.scrollY,
  })
}

const addCanvasSliceToPdf = (pdf, sourceCanvas, sourceY, sourceHeight, pageWidth, pageHeight, padding) => {
  const contentWidth = pageWidth - padding * 2
  const contentHeight = pageHeight - padding * 2
  const scale = contentWidth / sourceCanvas.width
  const sliceHeight = Math.min(sourceHeight, sourceCanvas.height - sourceY)

  const pageCanvas = document.createElement('canvas')
  pageCanvas.width = sourceCanvas.width
  pageCanvas.height = sliceHeight

  const context = pageCanvas.getContext('2d')
  context.fillStyle = '#ffffff'
  context.fillRect(0, 0, pageCanvas.width, pageCanvas.height)
  context.drawImage(
    sourceCanvas,
    0,
    sourceY,
    sourceCanvas.width,
    sliceHeight,
    0,
    0,
    sourceCanvas.width,
    sliceHeight
  )

  const imageHeight = sliceHeight * scale
  pdf.addImage(pageCanvas.toDataURL('image/png'), 'PNG', padding, padding, contentWidth, imageHeight)
}

const DownloadReportButton = ({ contentSelector = '#dashboard-report-content', filename = 'dashboard-report' }) => {
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownloadPDF = async () => {
    setIsDownloading(true)

    try {
      const element = document.querySelector(contentSelector)
      if (!element) {
        alert('Report content not found')
        return
      }

      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageWidth = 210
      const pageHeight = 297
      const padding = 10

      const canvas = await captureSection(element)
      const contentWidth = pageWidth - padding * 2
      const contentHeight = pageHeight - padding * 2
      const scale = contentWidth / canvas.width
      const pageSourceHeight = Math.floor(contentHeight / scale)

      let sourceY = 0
      let pageIndex = 0

      while (sourceY < canvas.height) {
        if (pageIndex > 0) {
          pdf.addPage()
        }

        addCanvasSliceToPdf(pdf, canvas, sourceY, pageSourceHeight, pageWidth, pageHeight, padding)
        sourceY += pageSourceHeight
        pageIndex += 1
      }

      const timestamp = new Date().toISOString().slice(0, 10)
      pdf.save(`${filename}-${timestamp}.pdf`)
    } catch (error) {
      console.error('Error generating PDF:', error)
      alert('Failed to generate PDF. Please try again.')
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <Button
      variant='primary'
      onClick={handleDownloadPDF}
      disabled={isDownloading}
      className='w-100'
    >
      {isDownloading ? (
        <>
          <Spinner size='sm' className='me-2' animation='border' />
          Generating...
        </>
      ) : (
        'Download Report'
      )}
    </Button>
  )
}

export default DownloadReportButton
